import Address, { ModelType } from "./model";
import normalizedActions from "../utils/normalized/actions";

export function addAddressNormalizedData(data, associations) {
  return (dispatch) => {
    let address = new Address();
    address.deserialize(data, associations);
    dispatch(addAddress(address));
  };
}

export function addAddress(data, associations) {
  return (dispatch, getState) => {
    return normalizedActions.updateOrCreateModel(
      dispatch,
      getState().addresses,
      ModelType,
      data,
      associations,
    );
  };
}
